/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'


type registerRequest = {
  firstName: string,
  lastName: string,
  email: string,
  membershipType: string,
  phoneNumber: string
}

const authBasePath = '/membership/members'

const membershipEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchMembers: builder.query<any, string>({
    query: () => ({
      url: `${authBasePath}`,
      method: 'get',
    }),
    providesTags: ['members'],
  }),

  createMember: builder.mutation<any, any>({
    query: (body) => ({
      url: `${authBasePath}/register`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['members'],
  }),

})

export default membershipEndpoints



